const firebaseConfig = {
    apiKey: "AIzaSyDeF0zxa8IuNT6iBZb2O0vgVUpiYT1ifUs",
    authDomain: "coxatour.firebaseapp.com",
    projectId: "coxatour",
    storageBucket: "coxatour.appspot.com",
    messagingSenderId: "140116325357",
    appId: "1:140116325357:web:2bb49f96baf1b898b22de4"
  };

  export default firebaseConfig;